const apiUrl = process.env.VUE_APP_API_URL
import axios from 'axios'
import request from '@/utils/request'
import { getModules } from '@/api/modulesApi'
const headers = {
    headers: {
        Authorization: `Bearer ${localStorage.getItem('vueauth_token')}`,
    },
}
export default {
    async addDataSegment({ commit }, payload) {
        commit('setLoading', true)
        try {
            let { data } = await axios.post(
                apiUrl + 'users/data-segments',
                payload,
                headers
            )
            commit('setSuccess', data.message)
            commit('reloadList', true)
            return data
        } catch (errors) {
            console.log(Object.keys(errors.response.data.errors)[0])
            commit('setLoading', false)
            commit(
                'setError',
                errors.response.data.errors[
                    Object.keys(errors.response.data.errors)[0]
                ]
            )
        }
    },
    async updateDataSegment({ commit }, payload) {
        commit('setLoading', true)
        try {
            let { data } = await axios.put(
                apiUrl + 'access-control/data-segments/' + payload.id,
                payload,
                headers
            )
            commit('setSuccess', data.message)
            commit('reloadList', true)
        } catch (errors) {
            commit('setLoading', false)
            commit(
                'setError',
                errors.response.data.errors[
                    Object.keys(errors.response.data.errors)[0]
                ]
            )
        }
    },
    async addIDVConfig({ commit }, { queryParams, payload }) {
        commit('setLoading', true)
        commit('reloadList', false)
        try {
            let { data } = await axios.post(
                apiUrl + 'access-control/idv-app-config' + queryParams,
                payload,
                headers
            )
            commit('setSuccess', data.message)
            commit('reloadList', true)
            commit('setLoading', false)
            return data
        } catch (errors) {
            console.log(Object.keys(errors.response.data.errors)[0])
            commit('setLoading', false)
            commit(
                'setError',
                errors.response.data.errors[
                    Object.keys(errors.response.data.errors)[0]
                ]
            )
        }
    },
    async updateIDVConfig({ commit }, { queryParams, payload }) {
        commit('setLoading', true)
        try {
            let { data } = await axios.put(
                apiUrl +
                    'access-control/idv-app-config/' +
                    payload.id +
                    queryParams,
                payload,
                headers
            )
            commit('setSuccess', data.message)
            commit('reloadList', true)
            commit('setLoading', false)

            return data
        } catch (errors) {
            commit('setLoading', false)
            commit('setError', errors.response.data.message)

            throw errors.response.data
        }
    },
    async updateIDVRemainingCount({ commit }, payload) {
        commit('setLoading', true)
        try {
            let { data } = await axios.post(
                apiUrl +
                    'access-control/idv-app-config/update-remaining-count/' +
                    payload.id,
                payload,
                headers
            )
            commit('setSuccess', data.message)
            commit('setLoading', false)

            return data
        } catch (errors) {
            commit('setLoading', false)
            commit(
                'setError',
                errors.response.data.errors[
                    Object.keys(errors.response.data.errors)[0]
                ]
            )
        }
    },
    async getAllDataSegments({ commit }, payload) {
        try {
            await axios.get(apiUrl + 'access-control/data-segments/', {
                params: payload,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        'vueauth_token'
                    )}`,
                },
            })
            // commit('setDataSegmentList', data)
        } catch (errors) {
            console.log(errors)
            commit('setLoading', false)
            commit('setError', errors.response.data.message)
        }
    },
    async fetchDataSegmentDetail({ commit }, dataSegmentId) {
        if (!dataSegmentId) {
            commit('setDataSegmentDetail', null)
            return
        }
        try {
            // getModules handles setDataSegmentConfigurations + encryptionKey automatically
            const { data } = await getModules(dataSegmentId)
            commit('setDataSegmentDetail', data.data)
            commit('setDataSegmentConfigurations', data.data)
            return data
        } catch (error) {
            console.error('Error fetching data segment detail:', error)
            commit('setDataSegmentDetail', null)
            throw error
        }
    },
}
